module.exports = __webpack_public_path__ + "24a4643020dabf126dcf5ce2afed5d5f.pdf";